import * as React from "react"
import { Container, Row, Col } from "react-bootstrap" 


const heroTitle = "Rose's Spa"
const heroSubtitle = "Ease in from one paradise to the next."
const heroParagraph = "An opportunity to relieve tension and tight muscle in your body by indulging in the services provided by our expert massage therapists. Enjoy the delights of profound pampering by the beach or privately in your villas. Our treatments and massages combine natural products and a holistic approach to sooth your body and relax your mind."
const buttonText = "Make an appointment"

function SpaHero() {
	return (

    <div className="spa-hero">
        
        <Container id="wrapping">
            <Row>
                <Col sm="5">
                    <div className="left">
                        <div className="hero-title">
                            <h1>{heroTitle}</h1>
                        </div>
                    </div>
                </Col>
                <Col sm="7">
                    <div className="right">
                        <div className="hero-text">
                            <h3>{heroSubtitle}</h3>
                            {/*<a href="https://media.graphassets.com/fWzOuJ2qSSefovVzW5Ya" target="_blank" referrer="noreferrer">
                            <Button id="button-one-white"><h4>{buttonText}</h4></Button>
    </a>*/}
                            <p>{heroParagraph}</p>
                        </div>
                    </div>
                </Col>
            </Row>

        </Container>

	</div>

    );
}

export default SpaHero;